/** 取り込み中のファイルをルート遷移をまたいで受け渡す（アップロード処理はワークスペース側で実行）。 */
const pending = new Map();

export const stashFiles = (batchId, files) => { pending.set(batchId, Array.from(files || [])); };

export const takeFiles = (batchId) => {
  const f = pending.get(batchId) || [];
  pending.delete(batchId);
  return f;
};
